import { i18nObject } from 'boot/i18n'
import { useHelpers } from 'src/common/composition/useHelpers'

export function notification(messageOptions, context) {
  const $helpers = useHelpers(context)

  const { text, title, timer, type = 'info', canClose = true, message = false, actions = [], html } = messageOptions
  const avatar = require(`../../assets/icon/svg/${type}.svg`)
  const closeBtn = {
    icon: 'las la-times',
    color: 'white',
    class: 'message-close-btn',
    handler: () => {},
  }

  if (canClose) {
    actions.push(closeBtn)
  }

  $helpers.notify({
    avatar,
    message: title || i18nObject.global.t('notification'),
    caption: text || '',
    position: 'top-right',
    timeout: timer || 5000,
    actions,
    classes: message && '--message',
    html: html,
  })
}

export function errorHandling(error, notify = true) {
  const errorsMessages = error.graphQLErrors?.map(({ message }) => message)?.join('. ')
  const errorsDetails = error.graphQLErrors?.map(({ extensions }) => extensions?.detail)?.join('. ')
  if (errorsMessages.length || errorsDetails.length) {
    if (notify) {
      notification({ text: errorsDetails || errorsMessages })
    }
    return errorsDetails || errorsMessages
  } else {
    if (notify) {
      notification({ text: i18nObject.t('serverErrorTryAgain') })
    }
    return i18nObject.t('serverErrorTryAgain')
  }
}
